import { BehaviorSubject } from 'rxjs';

export type SortParams = { sortBy: string; sortOrder: 'ASC' | 'DESC' } | null;

export abstract class SortableTableComponent {
  protected readonly sort$ = new BehaviorSubject<SortParams>(null);

  onSortChanged(sort: SortParams) {
    this.sort$.next(sort);
  }
}
